/**
 * Check if a the value is a valid email-address
 */
export const isValidEmail = (value?: string): string | void =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? 'global.not_a_valid_email_address' : undefined
